import React from 'react';
import { Plus, Copy, Trash2, Battery } from 'lucide-react';
import { usePlanStore } from '../store/usePlanStore';
import SessionCard from './SessionCard';

export default function WeekView() {
  const {
    plan,
    activeWeekIndex,
    setActiveWeek,
    addWeek,
    removeWeek,
    duplicateWeek,
    toggleDeload,
    addSession,
  } = usePlanStore();

  if (!plan) return null;

  const week = plan.weeks[activeWeekIndex];
  if (!week) return null;

  return (
    <div className="animate-fade-in">
      {/* ── Week Tabs ────────────────────── */}
      <div className="flex items-center gap-1 mb-4 overflow-x-auto pb-1 scrollbar-thin">
        {plan.weeks.map((w, idx) => (
          <button
            key={w.id}
            onClick={() => setActiveWeek(idx)}
            className={`
              relative px-3 py-1.5 rounded-lg text-xs font-semibold whitespace-nowrap transition-all
              ${
                idx === activeWeekIndex
                  ? 'bg-brand-600 text-white shadow-md'
                  : 'bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-700 hover:border-brand-400'
              }
              ${w.deload ? 'ring-2 ring-amber-400 ring-offset-1 dark:ring-offset-slate-950' : ''}
            `}
          >
            W{w.weekNumber}
            {w.deload && (
              <span className="ml-1 text-[10px] text-amber-200 dark:text-amber-400">D</span>
            )}
          </button>
        ))}
        <button
          onClick={addWeek}
          className="p-1.5 rounded-lg text-slate-400 hover:text-brand-600 hover:bg-slate-100 dark:hover:bg-slate-800 transition"
          title="Dodaj tydzień"
        >
          <Plus size={16} />
        </button>
      </div>

      {/* ── Week Header ──────────────────── */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <h2 className="text-lg font-bold">
            Tydzień {week.weekNumber}
            {week.deload && (
              <span className="ml-2 text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-950 px-2 py-0.5 rounded-full">
                DELOAD
              </span>
            )}
          </h2>
          <span className="text-xs text-slate-400">
            {week.sessions.length} {week.sessions.length === 1 ? 'sesja' : week.sessions.length < 5 ? 'sesje' : 'sesji'} ·{' '}
            {week.sessions.reduce((s, sess) => s + sess.exercises.length + (sess.warmupExercises || []).length, 0)} ćw.
          </span>
        </div>
        <div className="flex items-center gap-1">
          <button
            onClick={() => toggleDeload(week.id)}
            className={`p-1.5 rounded-lg text-xs font-medium transition ${
              week.deload
                ? 'bg-amber-100 dark:bg-amber-950 text-amber-700 dark:text-amber-400'
                : 'text-slate-400 hover:text-amber-600 hover:bg-amber-50 dark:hover:bg-amber-950'
            }`}
            title="Przełącz deload"
          >
            <Battery size={16} />
          </button>
          <button
            onClick={() => duplicateWeek(week.id)}
            className="p-1.5 rounded-lg text-slate-400 hover:text-brand-600 hover:bg-slate-100 dark:hover:bg-slate-800 transition"
            title="Duplikuj tydzień"
          >
            <Copy size={16} />
          </button>
          {plan.weeks.length > 1 && (
            <button
              onClick={() => removeWeek(week.id)}
              className="p-1.5 rounded-lg text-slate-400 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-950 transition"
              title="Usuń tydzień"
            >
              <Trash2 size={16} />
            </button>
          )}
        </div>
      </div>

      {/* ── Sessions Grid ────────────────── */}
      <div className="flex flex-col md:flex-row md:flex-wrap gap-4 items-start">
        {week.sessions.map((session) => (
          <div
            key={session.id}
            className="w-full md:min-w-[340px] md:w-[420px] md:max-w-[920px] md:resize-x md:overflow-auto"
            title="Przeciągnij prawą krawędź, aby zmienić szerokość"
          >
            <SessionCard
              weekId={week.id}
              session={session}
            />
          </div>
        ))}

        {/* Add session card */}
        <button
          onClick={() => addSession(week.id)}
          className="w-full md:min-w-[340px] md:w-[420px] md:max-w-[920px] flex flex-col items-center justify-center gap-2 min-h-[120px] rounded-xl border-2 border-dashed border-slate-200 dark:border-slate-700 text-slate-400 hover:text-brand-500 hover:border-brand-400 transition-all group"
        >
          <Plus size={24} className="group-hover:scale-110 transition-transform" />
          <span className="text-xs font-medium">Dodaj sesję</span>
        </button>
      </div>
    </div>
  );
}
